var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"subtitle has-text-centered store-name"},[(!_vm.vendingsOnly)?_c('button',{staticClass:"button is-small is-rounded is-pulled-left store-type-button",class:{
      'is-smart-orange':
        _vm.type === 'market' ||
        _vm.type === 'marketRoom' ||
        _vm.type === 'marketAquarium',
      'is-deep-purple': _vm.type === 'station',
      'is-elegant-black': _vm.type === 'box',
      'is-warning': _vm.type === 'dc',
      'is-light': _vm.type === 'vending' || _vm.type === 'locker'
    }},[_vm._v("\n    "+_vm._s(_vm.type === "market" || _vm.type === "marketRoom" || _vm.type === "marketAquarium"
        ? "Market"
        : _vm.type === "station"
        ? "Station"
        : _vm.type === "box"
        ? "Box"
        : _vm.type === "vending"
        ? "Vending"
        : _vm.type === "locker"
        ? "Locker"
        : _vm.type === "dc"
        ? "Centro de Distribuição"
        : "-")+"\n  ")]):_vm._e(),_vm._v("\n\n  "+_vm._s(_vm.name)+"\n  "),_c('hr',{staticStyle:{"margin":"0.7rem 0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }